import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {gsap} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../../components/BasicBitmapCountUp";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {BenjiKIVGameAssets} from "../../BenjiKIVGameAssets";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

/**
 * Class description
 *
 * Created: 2021-11-18
 * @author jonas
 */
export class BenjiKIVOutroView extends PIXI.Container implements StageLayer {

    private _outroContainer:PIXI.Container;
    private _button:ContinueButton;
    private _clickCallback:Function;
    private countUp:BasicBitmapCountUp;
    protected _background:PIXI.Sprite;
    private _totalWin: PIXI.Text;
    private _multipliers: PIXI.Sprite[] = [];

    constructor() {
        super();
        this.init();
    }

    protected getOutroContent():PIXI.Container {
        return new PIXI.Container();
    }

    private init(): void {
        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.tint = 0x000000;
        this._background.alpha = 0;
        this.addChild(this._background);

        this._outroContainer = this.getOutroContent();
        this._outroContainer.alpha = 0;
        this.addChild(this._outroContainer);

        let multiplierFrame: PIXI.Sprite,
            multiplierText: PIXI.BitmapText;
        for (let i: number = 0; i < 5; i++) {
            multiplierFrame = new PIXI.Sprite(BenjiKIV.assetLoader.getTextures("Scatter/S_Frame")[0]);
            multiplierFrame.visible = false;
            multiplierFrame.anchor.set(0.5);
            multiplierFrame.scale.set(0.7);
            multiplierFrame.y = 480;

            multiplierText = new PIXI.BitmapText("0x", {
                fontName : BenjiKIVGameAssets.BITMAP_FONT_SYMBOL_MULTIPLIER,
                fontSize : 70
            });
            multiplierText.anchor = new PIXI.Point(0.5, 0.5);
            multiplierText.position.set(-16, 0);
            multiplierFrame.addChild(multiplierText);

            this.addChild(multiplierFrame);
            this._multipliers.push(multiplierFrame);
        }

        this._totalWin = new PIXI.Text(BenjiKIV.apiPlugin.translations.translate("TOTAL WIN"), new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAngle: 8,
            dropShadowBlur: 3,
            dropShadowDistance: 3,
            fill: "#FFFF00",
            fontFamily: OpenSans.FAMILY,
            fontSize: 60,
            fontWeight: FontWeight.BOLD,
            lineJoin: "round",
            miterLimit: 6,
            strokeThickness: 4
        }));
        this._totalWin.visible = false;
        this._totalWin.anchor.set(0.5);
        this._totalWin.position.set(0, 180);

        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick());
        this._button.position.set(360, 615);
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false);
        this._button.alpha = 0;

        this.countUp = new BasicBitmapCountUp({
            fontName : BenjiKIVGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 190,
            tint : 0xffffff
        }, 720, new PIXI.Point(0.5, 0.5));
        this.countUp.position.set(0, 0);
        this.countUp.scale.set(0.8, 0.8);
        this.countUp.stopAt(0);
        this.countUp.position.set(0, this.getCountUpYPos());
        this.countUp.alpha = 0;

        this._outroContainer.addChild(this._totalWin, this.countUp);
        this._outroContainer.position = this.getOutroContainerPos();
        this.addChild(this._outroContainer);

        this.addChild(this._button);

        this.onResize();
    }

    private onButtonClick() {
        this._button.enable(false);
        this._clickCallback();
    }

    public hideOutro(isWinBelowStake:boolean):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            BenjiKIV.backgroundElements.setMode(BenjiKIVGameMode.NORMAL);
            BenjiKIV.keypadPlugin.setWin(BenjiKIV.model.accumulatedRoundWin, BenjiKIV.model.showTotalWin, isWinBelowStake);
        });
        tl.add(gsap.to(this._outroContainer, {duration : 1.0, alpha : 0}));
        tl.add(gsap.to(this._background, {duration : 1.0, alpha : 0}), "<");
        tl.add(gsap.to(this._button, {duration : 0.4, alpha : 0}), "<");
        tl.add(gsap.to([this._totalWin, this.countUp], {duration : 0.4, alpha : 0, onComplete: () => {
                this._totalWin.visible = false;
                this._totalWin.alpha = 1;
            }
        }), "<");
        tl.add(gsap.to(this._multipliers, {duration : 0.4, alpha : 0, onComplete: () => {
                this._multipliers.forEach((multi: PIXI.Sprite) => {
                    multi.visible = false;
                    multi.alpha = 1;

                    (multi.children[0] as PIXI.BitmapText).text = "0x";
                });
            }
        }), "<");

        tl.add(() => {
            NolimitApplication.removeLayer(this.name);
            BenjiKIV.model.buyFeatureName = "";
            BenjiKIV.xBetView.show();
        })
        return tl;
    }

    onResize():void {
        const bounds:ScreenBounds = NolimitApplication.screenBounds;
        //Copied from Launcher/GameIntroView, so we get consistent placement of buttons
        if(NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }

        this._background.width = NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication.screenBounds.height;
        this._background.x = NolimitApplication.screenBounds.left;
        this._background.y = NolimitApplication.screenBounds.top;
    }

    public showButton():gsap.core.Timeline {
        const tl:gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => this._button.enable(true));
        tl.add(gsap.to(this._button, {duration : 0.2, alpha : 1}));
        return tl;
    }

    public getCountUp(amount:number, countDuration:number = 2, isWinBelowStake:boolean):gsap.core.Timeline {
        const tl:gsap.core.Timeline = new gsap.core.Timeline();

        if(isWinBelowStake) {
            countDuration = 0;
        }

        tl.add(() => {
            this._totalWin.visible = (!isWinBelowStake && (amount > 0));

            if (BenjiKIV.model.gameData?.mode === BenjiKIVGameMode.SUPER_FREESPIN) {
                const multipliers: number[] = [],
                    activeOverlayScattersLength: number = BenjiKIV.model.gameData.overlayScatter.length;
                let multiText: PIXI.BitmapText,
                    xPos: number[] = [150, 290, 430, 570];

                if (activeOverlayScattersLength === 5) {
                    xPos = [90, 225, 360, 495, 630];
                }

                for (let i: number = 0; i < activeOverlayScattersLength; i++) {
                    multipliers.push(BenjiKIV.model.multiplierScatters[i]);
                }
                multipliers.sort((a: number, b: number) => a - b);

                for (let i: number = 0; i < activeOverlayScattersLength; i++) {
                    multiText = (this._multipliers[i].children[0] as PIXI.BitmapText)
                    multiText.text = multipliers[i] + "x";
                    this.adjustMultiplierSize(multiText);

                    this._multipliers[i].x = xPos[i];
                    this._multipliers[i].visible = true;
                }
            }
        }, 0);

        if(countDuration > 0) {
            if (amount > 0){
                tl.add(() => BenjiKIV.soundPlayer.startCountUp());
            }
            tl.add(this.countUp.getCountAnimation(0, amount, countDuration));
            tl.add(() => BenjiKIV.soundPlayer.stopCountUp(undefined, false));
            tl.add(() => {
                if(BenjiKIV.model.wasFeatureBuy) {
                    if(amount < (BenjiKIV.getBuyFeaturePrice() * 0.10)) {
                        BenjiKIV.soundPlayer.playSound(BenjiKIVSound.COUNT_UP_END_BAD_FS_AND_SFS);
                    }else {
                        BenjiKIV.soundPlayer.playSound(BenjiKIVSound.COUNT_UP_END_GOOD_FS_AND_SFS);
                    }
                } else {
                    if(BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN && (amount < (BenjiKIV.model.gameData.playedBetValue * 5))
                    || BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN && (amount < (BenjiKIV.model.gameData.playedBetValue * 30))) {
                        BenjiKIV.soundPlayer.playSound(BenjiKIVSound.COUNT_UP_END_BAD_FS_AND_SFS);
                    } else {
                        BenjiKIV.soundPlayer.playSound(BenjiKIVSound.COUNT_UP_END_GOOD_FS_AND_SFS);
                    }
                }
            })
        } else {
            tl.add(() => this.countUp.stopAt(amount));
        }

        tl.add(gsap.to(this.countUp, {duration : 0.6, alpha : 1}), 0);
        tl.add(() => BenjiKIV.keypadPlugin.setWin(amount, BenjiKIV.model.showTotalWin, isWinBelowStake));

        return tl;
    }

    public showOutro(callback:Function):gsap.core.Timeline {
        this.countUp.position.y = this.getCountUpYPos();
        this._clickCallback = callback;
        const tl:gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => this.onResize());
        tl.add(() => NolimitApplication.addLayer(this.name, this));

        tl.add(() => {BenjiKIV.soundPlayer.playSound(BenjiKIVSound.FS_AND_SFS_OUTRO)});

        tl.add(gsap.to(this._background, {duration : 0.6, alpha : 0.7}));
        tl.add(gsap.to(this._outroContainer, {duration : 0.6, alpha : 1}));

        return tl;
    }

    protected getCountUpYPos() {
        return 355;
    }

    protected getOutroContainerPos():PIXI.Point {
        return new PIXI.Point(360, 0);
    }

    private adjustMultiplierSize(item: PIXI.BitmapText): void {
        item.fontSize = 70;

        while (item.width > 120) {
            item.fontSize--;
            item.updateTransform();
        }
    }
}